export default "__VITE_ASSET__DcRyTYQk__"